function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { Button } from '@deephaven/components';
import Log from '@deephaven/log';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsWarning } from '@deephaven/icons';
import { FormatColumnWhereIcon, FormatRowWhereIcon } from "../icons/index.js";
import MultiColumnFormatEditor from "./MultiColumnFormatEditor.js";
import RowFormatEditor from "./RowFormatEditor.js";
import { FormatterType, isSupportedColumn } from "./ConditionalFormattingUtils.js";
import "./ConditionalFormatEditor.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('ConditionalFormatEditor');
var DEFAULT_CALLBACK = () => undefined;
function getFormatterTypeIcon(option) {
  switch (option) {
    case FormatterType.CONDITIONAL:
      return /*#__PURE__*/_jsx(FormatColumnWhereIcon, {});
    case FormatterType.ROWS:
      return /*#__PURE__*/_jsx(FormatRowWhereIcon, {});
  }
}
function getFormatterTypeLabel(option) {
  switch (option) {
    case FormatterType.CONDITIONAL:
      return 'Conditional';
    case FormatterType.ROWS:
      return 'Rows';
  }
}
var formatterTypes = [FormatterType.CONDITIONAL, FormatterType.ROWS];
function ConditionalFormatEditor(props) {
  var _defaultRule$type;
  var originalColumns = props.columns,
    dh = props.dh,
    errorMessage = props.errorMessage,
    _props$onSave = props.onSave,
    onSave = _props$onSave === void 0 ? DEFAULT_CALLBACK : _props$onSave,
    _props$onUpdate = props.onUpdate,
    onUpdate = _props$onUpdate === void 0 ? DEFAULT_CALLBACK : _props$onUpdate,
    _props$onCancel = props.onCancel,
    onCancel = _props$onCancel === void 0 ? DEFAULT_CALLBACK : _props$onCancel,
    defaultRule = props.rule;
  var columns = originalColumns.filter(isSupportedColumn);
  var _useState = useState((_defaultRule$type = defaultRule === null || defaultRule === void 0 ? void 0 : defaultRule.type) !== null && _defaultRule$type !== void 0 ? _defaultRule$type : formatterTypes[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFormatter = _useState2[0],
    setFormatter = _useState2[1];
  var _useState3 = useState(defaultRule),
    _useState4 = _slicedToArray(_useState3, 2),
    rule = _useState4[0],
    setRule = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isValid = _useState6[0],
    setIsValid = _useState6[1];
  var handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);
  var handleSave = useCallback(() => {
    if (rule === undefined) {
      log.error('Rule is not defined.');
      return;
    }
    onSave(rule);
  }, [onSave, rule]);
  var handleFormatterChange = useCallback(value => {
    log.debug('handleFormatterChange', value);
    setFormatter(value);
  }, []);
  var handleRuleChange = useCallback((ruleConfig, isRuleValid) => {
    log.debug('handleRuleChange', ruleConfig, isRuleValid, selectedFormatter);
    var updatedRule = {
      type: selectedFormatter,
      config: ruleConfig
    };
    setRule(updatedRule);
    setIsValid(isRuleValid);
    onUpdate(isRuleValid ? updatedRule : undefined);
  }, [onUpdate, selectedFormatter]);
  return /*#__PURE__*/_jsxs("div", {
    className: "conditional-format-editor form",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mb-2",
      children: [/*#__PURE__*/_jsx("label", {
        className: "mb-0",
        htmlFor: "formatter-select",
        children: "Select Formatter"
      }), /*#__PURE__*/_jsx("div", {
        className: "formatter-list",
        children: formatterTypes.map((type, index) => /*#__PURE__*/_jsx("div", {
          className: "formatter-type",
          children: /*#__PURE__*/_jsxs("button", {
            type: "button",
            className: classNames('btn', 'btn-icon', 'btn-formatter-type', {
              active: type === selectedFormatter
            }),
            "data-index": index,
            onClick: () => handleFormatterChange(type),
            children: [getFormatterTypeIcon(type), getFormatterTypeLabel(type)]
          })
        }, type))
      })]
    }), selectedFormatter === FormatterType.CONDITIONAL && /*#__PURE__*/_jsx(MultiColumnFormatEditor, {
      columns: columns,
      dh: dh,
      config: rule === null || rule === void 0 ? void 0 : rule.config,
      onChange: handleRuleChange
    }), selectedFormatter === FormatterType.ROWS && /*#__PURE__*/_jsx(RowFormatEditor, {
      columns: columns,
      config: rule === null || rule === void 0 ? void 0 : rule.config,
      dh: dh,
      onChange: handleRuleChange
    }), /*#__PURE__*/_jsx("hr", {}), errorMessage != null && errorMessage !== '' && /*#__PURE__*/_jsxs("div", {
      className: "error-message",
      children: [/*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsWarning
        }), " Failed to preview conditional formatting."]
      }), /*#__PURE__*/_jsx("div", {
        className: "error-box",
        children: errorMessage
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "d-flex justify-content-end my-3",
      children: [/*#__PURE__*/_jsx(Button, {
        kind: "secondary",
        onClick: handleCancel,
        className: "mr-2",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        kind: "primary",
        onClick: handleSave,
        disabled: rule === undefined || !isValid || errorMessage != null,
        children: "Done"
      })]
    })]
  });
}
export default ConditionalFormatEditor;
//# sourceMappingURL=ConditionalFormatEditor.js.map